<template>
	<div class="grid gap-3"><slot/></div>
</template>
<script setup lang="ts"></script>